import ReactExport from 'react-export-excel';
import * as moment from 'moment';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Index = ({ data, name }) => {
  let header = '';
  if (data.length > 0) {
    header = Object.keys(data[0]).map((m, index) => {
      return <ExcelColumn label={m} value={m} key={index} />;
    });
  }
  return (
    <ExcelFile
      hideElement
      filename={name.replace(/ +/g, '_') + moment().format('MMDDYYYY')}
      key={(Math.random() + 1).toString(36).substring(7)}
    >
      <ExcelSheet data={data} name={name}>
        {header}
      </ExcelSheet>
    </ExcelFile>
  );
};

export default Index;
